
import * as Immutable from "immutable";
import { GuestbookEntry } from "../types/types";
export const averageRating = (entries: Immutable.List<GuestbookEntry>) : number => {
  if (entries.count() == 0) {
    return null;
  }

  const sum = entries.map(x => x.rating).reduce<number>((prev, current) => prev + current)
  return sum / entries.count();
}
